import { observer } from "mobx-react";
import * as React from "react";
import { VideoNodeStore } from "../../../stores";
import { TopBar } from "../TopBar";
import { ResizableNodeView } from "../ResizableNodeView";
import "./../NodeView.scss";
import "./VideoNodeView.scss";

interface VideoNodeProps {
    store: VideoNodeStore;
}

/**
 * This class represents the view for a video node.
 * It extends ResizableNodeView to support interactive resizing
 * while displaying video content sourced from the node store.
 */
@observer
export class VideoNodeView extends ResizableNodeView<VideoNodeStore> {
    
    /**
     * This getter method returns the CSS class name for the video node.
     * @returns Class name for the video node container.
     */
    protected getNodeClassName(): string {
        return "videoNode";
    }

    /**
     * This method renders the visual content of the video node, 
     * including the top bar.
     * @returns Node representing the video node content
     */
    protected renderContent(): React.ReactNode {
        const store = this.props.store;
        return (
            <>
                <TopBar store={store} />
                <div className="scroll-box">
                    <div className="content">
                        <h3 className="title">{store.title}</h3>
                        <video src={store.url} controls />
                    </div>
                </div>
            </>
        );
    }
}